/// <reference path="../../../tools/typings/tsd.d.ts"/>
/// <reference path="../../../tools/typings/angularjs/angular.d.ts"/>
/// <reference path="../services.ts"/>

namespace DealerwareWebServices
{
    "use strict";

    export class DealerwareInternationalizationData {
      public static $inject: string[] = [
        '$http',
        '$window',
      ];

      public data: any = {};
      public FR = 'fr';
      public FR_CA = 'fr-CA'; 
      public EN = 'en';

      constructor(public $http: any, public $window: any) {}

      getLabels(): any {
        const lng = this.$window.location.pathname;
        return this.$http({
          method: 'GET',
          url: `${lng}samples/data_dictionary.json`
        });
      }

      getLabelsByModule(dataResponse: any, module: string): Object {
        const data = dataResponse;
        const k = Object.keys(data).find(el => el === module);
        return data[k];
      }

      formatLabelsByLanguage(language: string, labels): {} {
        const formatted = {};

        Object.entries(labels).forEach( ([k,v]) => {
            formatted[k] = (language !== this.EN && language !== undefined) ? this.capitalizeFirst(v) : v;
        })

        return formatted;
      }

      capitalizeFirst(str: string) : string {
        const label = str.toLowerCase();
        return (angular.isString(label) && label.length > 0) ? label.charAt(0).toUpperCase() + label.slice(1) : label;
      }

      getMomentDataFromLocale(): Object {
        return this.$http({
          method: 'GET',
          url: `samples/moment_locale_data.json`
        });
      }

      getCurrencyLabel(amount: string) : string {
        if(localStorage.getItem('language') === this.FR) {
            return `${amount} $`;
        } else {
            return `$ ${amount}`;
        }
      }
    }

    getDealerwareWebServicesModule().service('$dealerwareInternationalizationData', DealerwareInternationalizationData);
}